import React, { type FunctionComponent, type SVGProps } from "react";
import { useTranslation } from "react-i18next";
import {
  CardContainer,
  CardContent,
  Description,
  IconWrapper,
  Title,
} from "./BenefitCard.styled";

interface BenefitCardProps {
  icon: FunctionComponent<
    SVGProps<SVGSVGElement> & {
      title?: string | undefined;
      titleId?: string | undefined;
      desc?: string | undefined;
      descId?: string | undefined;
    }
  >;
  titleKey: string;
  descriptionKey: string;
}

const BenefitCard: React.FC<BenefitCardProps> = ({
  icon,
  titleKey,
  descriptionKey,
}) => {
  const { t } = useTranslation();

  return (
    <CardContainer>
      <IconWrapper>{React.createElement(icon)}</IconWrapper>
      <CardContent>
        <Title>{t(titleKey)}</Title>
        <Description>{t(descriptionKey)}</Description>
      </CardContent>
    </CardContainer>
  );
};

export default BenefitCard;
